<div class="filter-active-issues py-2">
  <div class="modal-main">
    <div class="header">
      <div class="d-flex flex-row justify-content-between my-1">
        <div class="col-1 pointer-cursor" (click)="navigateBack(stepper)">
          <img
            src="/assets/svg/ico-chevron-back-outline.svg"
            class="back-navigation pointer-cursor"
            role="button"
          />
        </div>

        <div>
          <p class="modal-title text-center">
            {{ 'ACTIVE_ISSUE' | translate }}
          </p>
        </div>
        <div class="col-1 text-right">
          <img
            src="/assets/svg/ico-hamburger-close.svg"
            class="pointer-cursor"
            (click)="closeDialog()"
          />
        </div>
      </div>

      <div class="row my-3 mx-3 pt-1">
        <div class="col-3"></div>
        <div class="col-6">
          <p class="text-center heading1">
            {{ stepFlows[stepper] }}
          </p>
        </div>
        <div class="col-3" role="button" (click)="resetFilter(stepper)">
          <p class="text-right reset-btn">
            {{ 'RESET' | translate }}
          </p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="stepper === 0">
      <div class="item-list-container mx-2 mb-3">
        <!-- Building -->

        <div
          class="row py-2 filter-item pointer-cursor"
          (click)="changeStep(1)"
        >
          <div
            class="d-flex flex-row justify-content-center align-items-center col-2"
          >
            <img [src]="buildingIcon" class="icon" />
          </div>
          <div
            class="col-9 text-item d-flex flex-row justify-content-between align-items-center pr-2"
          >
            <p class="item-title pr-3">
              <app-with-tooltip [showHelpCursor]="true">
                {{ 'BUILDING' | translate }}
              </app-with-tooltip>
            </p>

            <p class="item-description">
              <app-with-tooltip [showHelpCursor]="true">
                {{ buildingDescription }}
              </app-with-tooltip>
            </p>
          </div>
          <div
            class="d-flex flex-row justify-content-center align-items-center pointer-cursor"
            role="button"
          >
            <img src="assets/svg/ico-chevron-forward-outline.svg" />
          </div>
        </div>

        <!-- Floor -->
        <div
          class="row py-2 filter-item pointer-cursor"
          matTooltip="Please select a building"
          [matTooltipDisabled]="buildingDescription?.length > 0"
          [matTooltipPosition]="'above'"
        >
          <div
            class="row w-100"
            [class.disabled-click]="buildingDescription?.length === 0"
            (click)="changeStep(2)"
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center col-2"
            >
              <img [src]="floorIcon" class="icon" />
            </div>
            <div
              class="col-9 text-item d-flex flex-row justify-content-between align-items-center pr-2"
            >
              <p class="item-title pr-3">
                <app-with-tooltip [showHelpCursor]="true">
                  {{ 'FLOOR' | translate }}
                </app-with-tooltip>
              </p>

              <p class="item-description">
                <app-with-tooltip [showHelpCursor]="true">
                  {{ floorDescription }}
                </app-with-tooltip>
              </p>
            </div>
            <div
              class="d-flex flex-row justify-content-center align-items-center pointer-cursor"
              role="button"
            >
              <img src="assets/svg/ico-chevron-forward-outline.svg" />
            </div>
          </div>
        </div>

        <!-- Wing -->

        <div
          class="row py-2 filter-item pointer-cursor"
          matTooltip="Please select a building"
          [matTooltipDisabled]="buildingDescription?.length > 0"
          [matTooltipPosition]="'above'"
        >
          <div
            class="row w-100"
            [class.disabled-click]="buildingDescription?.length === 0"
            (click)="changeStep(3)"
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center col-2"
            >
              <img src="assets/svg/ico-direction.svg" class="icon" />
            </div>
            <div
              class="col-9 text-item d-flex flex-row justify-content-between align-items-center pr-2"
            >
              <p class="item-title pr-3">
                <app-with-tooltip [showHelpCursor]="true">
                  {{ 'WING' | translate }}
                </app-with-tooltip>
              </p>

              <p class="item-description">
                <app-with-tooltip [showHelpCursor]="true">
                  {{ wingsDescription }}
                </app-with-tooltip>
              </p>
            </div>
            <div
              class="d-flex flex-row justify-content-center align-items-center pointer-cursor"
              role="button"
            >
              <img src="assets/svg/ico-chevron-forward-outline.svg" />
            </div>
          </div>
        </div>

        <!-- Event Type -->

        <div
          class="row py-2 filter-item pointer-cursor"
          (click)="changeStep(4)"
        >
          <div
            class="d-flex flex-row justify-content-center align-items-center col-2"
          >
            <img src="assets/svg/ico-lock.svg" class="icon" />
          </div>
          <div
            class="col-9 text-item d-flex flex-row justify-content-between align-items-center pr-2"
          >
            <p class="item-title pr-3">
              <app-with-tooltip [showHelpCursor]="true">
                {{ 'EVENT_TYPE' | translate }}
              </app-with-tooltip>
            </p>

            <p class="item-description">
              <app-with-tooltip [showHelpCursor]="true">
                {{ eventDescription }}
              </app-with-tooltip>
            </p>
          </div>
          <div
            class="d-flex flex-row justify-content-center align-items-center pointer-cursor"
            role="button"
          >
            <img src="assets/svg/ico-chevron-forward-outline.svg" />
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Building Selection  -->

    <ng-container *ngIf="stepper === 1">
      <app-check-selection-list
        [itemList]="buildings"
        [icon]="buildingIcon"
        (updateItemList)="updateItemList($event, CONSTANTS.SELECT_BUILDING)"
      ></app-check-selection-list>
    </ng-container>

    <!-- Floors Selection  -->

    <ng-container *ngIf="stepper === 2 && floors?.length > 0">
      <app-check-selection-list
        [itemList]="floors"
        [icon]="floorIcon"
        (updateItemList)="updateItemList($event, CONSTANTS.SELECT_FLOOR)"
      ></app-check-selection-list>
    </ng-container>

    <ng-container
      *ngIf="(stepper === 2 || stepper === 3) && floors?.length === 0"
    >
      <div
        class="d-flex flex-column justify-content-center py-130 align-items-center h-100"
      >
        <div
          class="text-container d-flex flex-column justify-content-center align-items-center"
        >
          <div class="icon-container">
            <img src="assets/svg/ico-floor.svg" class="home-icon" />
          </div>
          <div class="text-center mt-3">
            <p>{{ 'NO_FLOORS_AVAILABLE' | translate }}</p>
          </div>
        </div>
      </div>
      <div></div>
    </ng-container>

    <!-- WING Selection  -->

    <ng-container *ngIf="stepper === 3 && floors?.length > 0">
      <app-check-selection-list
        [itemList]="wings"
        [icon]="wingIcon"
        (updateItemList)="updateItemList($event, CONSTANTS.SELECT_WING)"
      ></app-check-selection-list>
    </ng-container>

    <!-- Event Codes Selection  -->

    <ng-container *ngIf="stepper === 4">
      <app-check-selection-list
        [itemList]="eventCodes"
        [icon]="eventTypeIcon"
        [multiSelection]="true"
        (updateItemList)="updateItemList($event, CONSTANTS.SELECT_EVENT_CODE)"
      ></app-check-selection-list>
    </ng-container>

    <div class="row mt-2 mx-2">
      <button
        class="btn btn-danger px-3 w-100 result-btn"
        type="button"
        tabindex="0"
        (click)="applyFilter()"
      >
        {{ 'SEE_RESULTS' | translate }}
      </button>
    </div>
  </div>
</div>
